/**
 * KAN-989: подтверждение покупки тарифа с кошелька.
 * "Списать N руб. с баланса? На балансе M руб."
 */
import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { Button } from '@/components/ui/button';
import { useWallet } from '@/hooks/useWallet';
import { formatWholeRub } from '@/lib/wallet';
import { isFreePrice } from '@/lib/tariffCharge';
import type { TariffPlan } from '@/types/voiceBilling';

interface Props {
  plan: TariffPlan | null;
  isPending: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export function TariffConfirmDialog({ plan, isPending, onConfirm, onCancel }: Props) {
  const wallet = useWallet();
  const free = plan !== null && isFreePrice(plan.price_monthly_rub);

  let balanceText = 'Загружаем остаток кошелька…';
  if (wallet.data) balanceText = `На балансе ${formatWholeRub(wallet.data.balance)} руб.`;
  else if (wallet.isError) balanceText = 'Не удалось загрузить остаток кошелька.';

  return (
    <AlertDialog
      open={plan !== null}
      onOpenChange={(open) => {
        if (!open && !isPending) onCancel();
      }}>
      <AlertDialogContent data-testid="tariff-confirm-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>Подключить тариф {plan?.name}</AlertDialogTitle>
          <AlertDialogDescription>
            {free && plan
              ? `Подключить тариф ${plan.name} бесплатно?`
              : plan
                ? `Списать ${formatWholeRub(plan.price_monthly_rub)} руб. с баланса? ${balanceText}`
                : ''}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="tariff-confirm-cancel" disabled={isPending}>
            Отмена
          </AlertDialogCancel>
          <Button data-testid="tariff-confirm-buy" onClick={onConfirm} disabled={isPending}>
            {isPending ? 'Подключаем…' : free ? 'Подключить бесплатно' : 'Списать и подключить'}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
